import { User } from "./user";

export class UserInfo extends User{

  constructor(userId: string, readonly name: string)
  {
    super(userId);
  }
}